import { Box, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import HomeIndicator from '@/designs-dev/device/HomeIndicator';

// Decorative iOS-style keyboard. Purely visual — keys don't type (typing goes
// through the real keyboard into the focused field). It slides up when `visible`
// and swallows mousedown so tapping it never blurs the field that summoned it.

export const KEYBOARD_H = 291;

const ROW1 = [...'qwertyuiop'];
const ROW2 = [...'asdfghjkl'];
const ROW3 = [...'zxcvbnm'];

const Key = ({
  label,
  icon,
  flex = 1,
  dark = false,
}: {
  label?: string;
  icon?: string;
  flex?: number;
  dark?: boolean;
}) => (
  <Box
    sx={{
      flex: flex,
      height: 42,
      minWidth: 0,
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: dark ? 'custom.neutral.300' : 'background.paper',
    }}
  >
    {icon ? (
      <Icon icon={icon as never} fontSize={16} />
    ) : (
      <Typography variant='body1'>{label}</Typography>
    )}
  </Box>
);

const MobileKeyboard = ({ visible }: { visible: boolean }) => (
  <Box
    onMouseDown={(e) => e.preventDefault()}
    sx={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: KEYBOARD_H,
      bgcolor: 'custom.neutral.200',
      px: 0.5,
      pt: 1,
      display: 'flex',
      flexDirection: 'column',
      userSelect: 'none',
      transform: visible ? 'translateY(0)' : 'translateY(100%)',
      transition: 'transform 240ms ease',
      willChange: 'transform',
    }}
  >
    {/* suggestion bar */}
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'space-around',
        height: 40,
        flexShrink: 0,
      }}
      direction='row'
    >
      {['KareHero', 'kare', 'care'].map((s) => (
        <Typography key={s} variant='body2' color='text.secondary'>
          {s}
        </Typography>
      ))}
    </Stack>

    <Stack sx={{ flex: 1, justifyContent: 'center' }} spacing={1}>
      <Stack direction='row' spacing={0.5}>
        {ROW1.map((k) => (
          <Key key={k} label={k} />
        ))}
      </Stack>
      <Stack sx={{ px: 2.5 }} direction='row' spacing={0.5}>
        {ROW2.map((k) => (
          <Key key={k} label={k} />
        ))}
      </Stack>
      <Stack direction='row' spacing={0.5}>
        <Key dark flex={1.5} label='⇧' />
        {ROW3.map((k) => (
          <Key key={k} label={k} />
        ))}
        <Key dark flex={1.5} label='⌫' />
      </Stack>
      <Stack direction='row' spacing={0.5}>
        <Key dark flex={1.4} label='123' />
        <Key dark flex={1} icon='smile' />
        <Key flex={5} label='space' />
        <Key dark flex={2} label='return' />
      </Stack>
    </Stack>

    <HomeIndicator />
  </Box>
);

export default MobileKeyboard;
